<script>
  let {
    assetsPath = '/',
    onAiMounted = () => {},
    onArtboardChange = () => {},
  } = $props();
  import { onMount, untrack } from 'svelte';
  let aiBox;
  let aiBoxWidth = $state(undefined);
  let allArtboards = $state([]);
  let activeArtboard = $state(undefined);
  onMount(() => {
    allArtboards = Array.from(aiBox.querySelectorAll('.g-artboard'));
    onAiMounted();
  });
  $effect(() => {
    if (aiBoxWidth) {
      const currentArtboard = allArtboards.filter((artboard) => {
        const minWidth = parseFloat(artboard.dataset.minWidth);
        const maxWidth = parseFloat(artboard.dataset.maxWidth) || Infinity;
        return minWidth <= aiBoxWidth && maxWidth >= aiBoxWidth;
      })[0];
      if (currentArtboard?.id !== activeArtboard?.id) {
        activeArtboard = untrack(() => currentArtboard);
        onArtboardChange(activeArtboard);
      }
    }
  });
</script>

<div
  id="g-Post-2_leadership-house-box"
  class="ai2svelte"
  bind:this={aiBox}
  bind:clientWidth={aiBoxWidth}
>
  <!-- Artboard: xs -->
  <div
    id="g-Post-2_leadership-house-xs"
    class="g-artboard"
    style="max-width: 509px;aspect-ratio: 1.0410094637224;"
    data-aspect-ratio="1.041"
    data-min-width="0"
    data-max-width="509"
  >
    <div
      id="g-Post-2_leadership-house-xs-img"
      class="g-Post-2_leadership-house-xs-img g-aiImg"
      alt=""
      style="background-image: url({assetsPath.replace(
        new RegExp('/([^/.]+)$'),
        '/$1/'
      ) || '/'}images/graphics/Post-2_leadership-house-xs.jpg);"
    ></div>
    <div
      id="g-ai0-6"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:83.1224%;margin-top:-7.5px;left:85.1466%;margin-left:-28px;width:56px;"
    >
      <p class="g-pstyle3">Tehran</p>
    </div>
    <div
      id="g-ai0-3"
      class="g-text g-aiAbs g-aiPointText"
      style="top:34.8312%;margin-top:-6.4px;left:13.1186%;width:131px;"
    >
      <p class="g-pstyle2">Imam Khomeini Hussainia</p>
    </div>
    <div
      id="g-ai0-4"
      class="g-text g-aiAbs g-aiPointText"
      style="top:53.154%;margin-top:-7.5px;left:63.6222%;width:66px;"
    >
      <p class="g-pstyle1">Hospital</p>
    </div>
    <div
      id="g-ai0-5"
      class="g-text g-aiAbs g-aiPointText"
      style="top:60.4095%;margin-top:-7.5px;left:15.7934%;width:115px;"
    >
      <p class="g-pstyle1">Leadership House</p>
    </div>
    <div
      id="g-ai0-2"
      class="g-text g-aiAbs g-aiPointText"
      style="top:31.0719%;margin-top:-7.5px;left:13.1186%;width:63px;"
    >
      <p class="g-pstyle1">Mosque</p>
    </div>
    <div
      id="g-ai0-1"
      class="g-text g-aiAbs g-aiPointText"
      style="top:19.8416%;margin-top:-21.9px;left:20.9374%;width:85px;"
    >
      <p class="g-pstyle0">Federal</p>
      <p class="g-pstyle0">government</p>
      <p class="g-pstyle0">office</p>
    </div>
  </div>
  <!-- Artboard: sm -->
  <div
    id="g-Post-2_leadership-house-sm"
    class="g-artboard"
    style="min-width: 510px;max-width: 659px;aspect-ratio: 1.2200956937799;"
    data-aspect-ratio="1.22"
    data-min-width="510"
    data-max-width="659"
  >
    <div
      id="g-Post-2_leadership-house-sm-img"
      class="g-Post-2_leadership-house-sm-img g-aiImg"
      alt=""
      style="background-image: url({assetsPath.replace(
        new RegExp('/([^/.]+)$'),
        '/$1/'
      ) || '/'}images/graphics/Post-2_leadership-house-sm.jpg);"
    ></div>
    <div
      id="g-ai1-6"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:83.8512%;margin-top:-7.5px;left:86.7704%;margin-left:-28px;width:56px;"
    >
      <p class="g-pstyle3">Tehran</p>
    </div>
    <div
      id="g-ai1-3"
      class="g-text g-aiAbs g-aiPointText"
      style="top:35.0474%;margin-top:-7.5px;left:25.3186%;width:153px;"
    >
      <p class="g-pstyle2">Imam Khomeini Hussainia</p>
    </div>
    <div
      id="g-ai1-4"
      class="g-text g-aiAbs g-aiPointText"
      style="top:53.6079%;margin-top:-9.1px;left:68.3986%;width:73px;"
    >
      <p class="g-pstyle1">Hospital</p>
    </div>
    <div
      id="g-ai1-5"
      class="g-text g-aiAbs g-aiPointText"
      style="top:60.5457%;margin-top:-9.1px;left:27.6001%;width:131px;"
    >
      <p class="g-pstyle1">Leadership House</p>
    </div>
    <div
      id="g-ai1-2"
      class="g-text g-aiAbs g-aiPointText"
      style="top:31.3591%;margin-top:-9.1px;left:25.3186%;width:70px;"
    >
      <p class="g-pstyle1">Mosque</p>
    </div>
    <div
      id="g-ai1-1"
      class="g-text g-aiAbs g-aiPointText"
      style="top:19.5888%;margin-top:-25.9px;left:31.988%;width:96px;"
    >
      <p class="g-pstyle0">Federal</p>
      <p class="g-pstyle0">government</p>
      <p class="g-pstyle0">office</p>
    </div>
  </div>
  <!-- Artboard: md -->
  <div
    id="g-Post-2_leadership-house-md"
    class="g-artboard"
    style="min-width: 660px;max-width: 929px;aspect-ratio: 1.41630901287554;"
    data-aspect-ratio="1.416"
    data-min-width="660"
    data-max-width="929"
  >
    <div
      id="g-Post-2_leadership-house-md-img"
      class="g-Post-2_leadership-house-md-img g-aiImg"
      alt=""
      style="background-image: url({assetsPath.replace(
        new RegExp('/([^/.]+)$'),
        '/$1/'
      ) || '/'}images/graphics/Post-2_leadership-house-md.jpg);"
    ></div>
    <div
      id="g-ai2-6"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:84.5667%;margin-top:-9.1px;left:88.3631%;margin-left:-31px;width:62px;"
    >
      <p class="g-pstyle4">Tehran</p>
    </div>
    <div
      id="g-ai2-3"
      class="g-text g-aiAbs g-aiPointText"
      style="top:35.7292%;margin-top:-7.5px;left:34.9516%;width:153px;"
    >
      <p class="g-pstyle2">Imam Khomeini Hussainia</p>
    </div>
    <div
      id="g-ai2-4"
      class="g-text g-aiAbs g-aiPointText"
      style="top:54.3987%;margin-top:-7.5px;left:72.1409%;width:66px;"
    >
      <p class="g-pstyle3">Hospital</p>
    </div>
    <div
      id="g-ai2-5"
      class="g-text g-aiAbs g-aiPointText"
      style="top:61.3908%;margin-top:-9.1px;left:36.9213%;width:131px;"
    >
      <p class="g-pstyle1">Leadership House</p>
    </div>
    <div
      id="g-ai2-2"
      class="g-text g-aiAbs g-aiPointText"
      style="top:31.9916%;margin-top:-9.1px;left:34.9516%;width:70px;"
    >
      <p class="g-pstyle1">Mosque</p>
    </div>
    <div
      id="g-ai2-1"
      class="g-text g-aiAbs g-aiPointText"
      style="top:19.9316%;margin-top:-25.9px;left:40.7092%;width:96px;"
    >
      <p class="g-pstyle0">Federal</p>
      <p class="g-pstyle0">government</p>
      <p class="g-pstyle0">office</p>
    </div>
  </div>
  <!-- Artboard: lg -->
  <div
    id="g-Post-2_leadership-house-lg"
    class="g-artboard"
    style="min-width: 930px;aspect-ratio: 1.5;"
    data-aspect-ratio="1.5"
    data-min-width="930"
  >
    <div
      id="g-Post-2_leadership-house-lg-img"
      class="g-Post-2_leadership-house-lg-img g-aiImg"
      alt=""
      style="background-image: url({assetsPath.replace(
        new RegExp('/([^/.]+)$'),
        '/$1/'
      ) || '/'}images/graphics/Post-2_leadership-house-lg.jpg);"
    ></div>
    <div
      id="g-ai3-6"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:84.22%;margin-top:-10.2px;left:88.7895%;margin-left:-34px;width:68px;"
    >
      <p class="g-pstyle3">Tehran</p>
    </div>
    <div
      id="g-ai3-3"
      class="g-text g-aiAbs g-aiPointText"
      style="top:35.6716%;margin-top:-10.2px;left:38.3635%;width:197px;"
    >
      <p class="g-pstyle2">Imam Khomeini Hussainia</p>
    </div>
    <div
      id="g-ai3-4"
      class="g-text g-aiAbs g-aiPointText"
      style="top:54.1527%;margin-top:-11.7px;left:73.4628%;width:88px;"
    >
      <p class="g-pstyle1">Hospital</p>
    </div>
    <div
      id="g-ai3-5"
      class="g-text g-aiAbs g-aiPointText"
      style="top:61.4108%;margin-top:-11.7px;left:40.2225%;width:162px;"
    >
      <p class="g-pstyle1">Leadership House</p>
    </div>
    <div
      id="g-ai3-2"
      class="g-text g-aiAbs g-aiPointText"
      style="top:31.8946%;margin-top:-11.7px;left:38.3635%;width:84px;"
    >
      <p class="g-pstyle1">Mosque</p>
    </div>
    <div
      id="g-ai3-1"
      class="g-text g-aiAbs g-aiPointText"
      style="top:19.7334%;margin-top:-33.3px;left:43.7975%;width:117px;"
    >
      <p class="g-pstyle0">Federal</p>
      <p class="g-pstyle0">government</p>
      <p class="g-pstyle0">office</p>
    </div>
  </div>
</div>

<!-- End ai2svelte - 2026-03-02 16:44 -->

<!-- Generated by ai2svelte v1.0.3 - 2026-03-02 16:44 -->
<!-- ai file: Post-2_leadership-house.ai -->
<style lang="scss">
  #g-Post-2_leadership-house-box {
    container-type: inline-size;
    container-name: g-Post-2_leadership-house-box;
  }
  #g-Post-2_leadership-house-box,
  #g-Post-2_leadership-house-box .g-artboard {
    margin: 0 auto;
  }
  #g-Post-2_leadership-house-box p {
    margin: 0;
  }
  #g-Post-2_leadership-house-box .g-aiAbs {
    position: absolute;
  }
  #g-Post-2_leadership-house-box .g-aiImg {
    position: absolute;
    top: 0;
    display: block;
    width: 100% !important;
    height: 100%;
    background-size: contain;
    background-repeat: no-repeat;
  }
  #g-Post-2_leadership-house-box .g-aiSymbol {
    position: absolute;
    box-sizing: border-box;
  }
  #g-Post-2_leadership-house-box .g-aiPointText p {
    white-space: nowrap;
  }
  #g-Post-2_leadership-house-box.g-aiPointText p {
    white-space: nowrap;
  }
  #g-Post-2_leadership-house-box {
    width: 100%;
    container-type: inline-size;
    @container (min-width:0px) and (max-width: 509px) {
      #g-Post-2_leadership-house-xs {
        display: block !important;
      }
    }
    @container (min-width:510px) and (max-width: 659px) {
      #g-Post-2_leadership-house-sm {
        display: block !important;
      }
    }
    @container (min-width:660px) and (max-width: 929px) {
      #g-Post-2_leadership-house-md {
        display: block !important;
      }
    }
    @container (min-width:930px) {
      #g-Post-2_leadership-house-lg {
        display: block !important;
      }
    }
  }
  #g-Post-2_leadership-house-xs {
    position: relative;
    overflow: hidden;
    display: none;
  }
  #g-Post-2_leadership-house-xs p {
    font-family: var(--theme-font-family-sans-serif), Knowledge, sans-serif;
    font-weight: regular;
    line-height: 14px;
    height: auto;
    opacity: 1;
    letter-spacing: 0em;
    font-size: 12px;
    text-align: left;
    color: rgb(255, 255, 255);
    text-transform: none;
    padding-bottom: 0;
    padding-top: 0;
    mix-blend-mode: normal;
    font-style: normal;
    position: static;
  }
  #g-Post-2_leadership-house-xs .g-pstyle0 {
    font-weight: 400;
    height: 14px;
  }
  #g-Post-2_leadership-house-xs .g-pstyle1 {
    font-weight: 700;
    height: 14px;
  }
  #g-Post-2_leadership-house-xs .g-pstyle2 {
    font-weight: 400;
    line-height: 12px;
    height: 12px;
    font-size: 10px;
  }
  #g-Post-2_leadership-house-xs .g-pstyle3 {
    font-weight: 400;
    height: 14px;
    text-align: center;
    color: rgb(165, 165, 166);
  }
  #g-Post-2_leadership-house-sm {
    position: relative;
    overflow: hidden;
    display: none;
  }
  #g-Post-2_leadership-house-sm p {
    font-family: var(--theme-font-family-sans-serif), Knowledge, sans-serif;
    font-weight: regular;
    line-height: 17px;
    height: auto;
    opacity: 1;
    letter-spacing: 0em;
    font-size: 14px;
    text-align: left;
    color: rgb(255, 255, 255);
    text-transform: none;
    padding-bottom: 0;
    padding-top: 0;
    mix-blend-mode: normal;
    font-style: normal;
    position: static;
  }
  #g-Post-2_leadership-house-sm .g-pstyle0 {
    font-weight: 400;
    height: 17px;
  }
  #g-Post-2_leadership-house-sm .g-pstyle1 {
    font-weight: 700;
    height: 17px;
  }
  #g-Post-2_leadership-house-sm .g-pstyle2 {
    font-weight: 400;
    line-height: 14px;
    height: 14px;
    font-size: 12px;
  }
  #g-Post-2_leadership-house-sm .g-pstyle3 {
    font-weight: 400;
    line-height: 14px;
    height: 14px;
    font-size: 12px;
    text-align: center;
    color: rgb(165, 165, 166);
  }
  #g-Post-2_leadership-house-md {
    position: relative;
    overflow: hidden;
    display: none;
  }
  #g-Post-2_leadership-house-md p {
    font-family: var(--theme-font-family-sans-serif), Knowledge, sans-serif;
    font-weight: regular;
    line-height: 17px;
    height: auto;
    opacity: 1;
    letter-spacing: 0em;
    font-size: 14px;
    text-align: left;
    color: rgb(255, 255, 255);
    text-transform: none;
    padding-bottom: 0;
    padding-top: 0;
    mix-blend-mode: normal;
    font-style: normal;
    position: static;
  }
  #g-Post-2_leadership-house-md .g-pstyle0 {
    font-weight: 400;
    height: 17px;
  }
  #g-Post-2_leadership-house-md .g-pstyle1 {
    font-weight: 700;
    height: 17px;
  }
  #g-Post-2_leadership-house-md .g-pstyle2 {
    font-weight: 400;
    line-height: 14px;
    height: 14px;
    font-size: 12px;
  }
  #g-Post-2_leadership-house-md .g-pstyle3 {
    font-weight: 700;
    line-height: 14px;
    height: 14px;
    font-size: 12px;
  }
  #g-Post-2_leadership-house-md .g-pstyle4 {
    font-weight: 400;
    height: 17px;
    text-align: center;
    color: rgb(165, 165, 166);
  }
  #g-Post-2_leadership-house-lg {
    position: relative;
    overflow: hidden;
    display: none;
  }
  #g-Post-2_leadership-house-lg p {
    font-family: var(--theme-font-family-sans-serif), Knowledge, sans-serif;
    font-weight: regular;
    line-height: 22px;
    height: auto;
    opacity: 1;
    letter-spacing: 0em;
    font-size: 18px;
    text-align: left;
    color: rgb(255, 255, 255);
    text-transform: none;
    padding-bottom: 0;
    padding-top: 0;
    mix-blend-mode: normal;
    font-style: normal;
    position: static;
  }
  #g-Post-2_leadership-house-lg .g-pstyle0 {
    font-weight: 400;
    height: 22px;
  }
  #g-Post-2_leadership-house-lg .g-pstyle1 {
    font-weight: 700;
    height: 22px;
  }
  #g-Post-2_leadership-house-lg .g-pstyle2 {
    font-weight: 400;
    line-height: 19px;
    height: 19px;
    font-size: 16px;
  }
  #g-Post-2_leadership-house-lg .g-pstyle3 {
    font-weight: 400;
    line-height: 19px;
    height: 19px;
    font-size: 16px;
    text-align: center;
    color: rgb(165, 165, 166);
  }

  /* Custom CSS */
  @mixin shadow-gorgonzola($clr) {
    $alpha: if(alpha($clr) != 1, alpha($clr), 1);
    text-shadow:
      rgba($clr, $alpha) 0px 0px 3px,
      rgba($clr, $alpha) 0px 0px 3px;
  }
  .g-text {
    @include shadow-gorgonzola(#000000);
  }
</style>
